export default function Experience() {
  return (
    <div>
      <div class="container experience">
        <h2 class="display-5">Work Experience</h2>
        <br />
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Senior Executive (Technology)</h5>
                <h6 class="card-subtitle mb-2 text-muted">MCX</h6>
                <p class="card-text">
                  Full Stack Developer - Angular + Spring boot. Involved in
                  maintaining & developing enterprise applications. Working on
                  Trading APIs - Interactive &amp; Multicast{" "}
                </p>
                <a
                  href="https://www.mcxindia.com"
                  class="card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About MCX
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Android Developer (Intern)</h5>
                <h6 class="card-subtitle mb-2 text-muted">Moodcafe</h6>
                <p class="card-text">
                  Involved in development of Moodcafe's official application.
                  Worked with Retrofit, Notifications via Firebase, Butterknife,
                  Dagger &amp; Room.
                </p>
                <a
                  href="https://www.moodcafe.in"
                  class="card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About Moodcafe
                </a>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Android Developer</h5>
                <h6 class="card-subtitle mb-2 text-muted">
                  GTU Innovation Council
                </h6>
                <p class="card-text">
                  Contributed in development of GIC's official application.
                  Worked with Volley library, JSON, MySQL.
                </p>
                <a
                  href="http://gtuinnovationcouncil.ac.in"
                  class="card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About GIC
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Android Developer (Intern)</h5>
                <h6 class="card-subtitle mb-2 text-muted">
                  Hitachi Hi-Rel Power Electronics
                </h6>
                <p class="card-text">
                  Developed my first Android app, to graphically demonstrate
                  company's resources using charts.{" "}
                </p>
                <a
                  href="http://www.hitachi-hirel.com"
                  class="card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About Hitachi Hi-Rel
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
